import { useEffect, useRef, useState } from "react";
import { ReactComponent as CloseSvg } from "../../assets/icons/close.svg";
import {
  AdminActionButton,
  AdminActionsContainer,
  ModalContainer,
  ModalContent,
  ModalTitle,
  ButtonGroup,
  Row,
  SmallRow,
  TitleContainer,
  Tags,
  Tag,
  FavoriteButton,
  NudifyContainer,
  UploadButton,
  Image,
  ImageContainer,
  NudifyText,
  FadeWrapper,
  SettingsContainer,
  LabelText,
  Column,
  Input,
  CheckboxContainer,
  Checkbox,
  CheckboxText,
  CheckboxContainerRow,
  ImageRelative,
  ArrowSvg,
  Textarea,
  DeleteButton,
  CropButton,
} from "./EditImageModal.styles";
import Modal from "../utils/Modal/Modal";
import { useLockBodyScroll } from "../../hooks/useLockBodyScroll";
import ConfirmationModal from "../ConfirmationModal/ConfirmationModal";

import { ReactComponent as CreditIcon } from "../../assets/icons/credit.svg";
import { ReactComponent as CropIcon } from "../../assets/icons/crop.svg";
import heic2any from "heic2any";

import CustomizeEditImageModal from "../CustomizeEditImageModal/CustomizeEditImageModal";
import {
  selectGenerateImageCollectionPending,
  selectHideCollectionPending,
  selectHideCollectionVipPending,
  selectToggleToFavoriteLoading,
} from "../../store/slices/model/slice";
import {
  generateImageCollection,
  hideCollection,
  hideCollectionVip,
  toggleToFavorite,
} from "../../store/slices/model/asyncThunks";
import { selectUser } from "../../store/slices/user/slice";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "sonner";
import { useNavigate } from "react-router-dom";
import {
  EDIT_IMAGE_MODEL_NAME,
  NUDIFY_MODEL_NAME,
  QWEN_Z_TWO_INPUT_IMAGES,
  TEXT_ON_BODY_MODEL_NAME,
  ALLOWED_HIDE_COLLECTION_USER_IDS,
  UPSCALE,
} from "../../utils/constants";
import LottieIcon from "../LottieIcon/LottieIcon";
import likeAnimation from "../../assets/animations/like.json";
import checkboxAnimation from "../../assets/animations/checkBox.json";
import radioButtonAnimation from "../../assets/animations/radioButton.json";
import settingsAnimation from "../../assets/animations/settings.json";
import deleteAnimation from "../../assets/animations/trash.json";
import FlyToCollection from "../FlyToCollection/FlyToCollection";
import { triggerCollectionTabAnimation } from "../../store/slices/common/slice";
import ExplosionButton from "../ExplosionButton/ExplosionButton";
import { useMediaQuery } from "react-responsive";
import CropModal from "../CropModal/CropModal";
import GenerationToast from "../utils/GenerationToast";
import { useScrollFade } from "../../hooks/useScrollFade";

const WHERE_OPTIONS = [
  { id: "forehead", label: "Forehead" },
  { id: "face", label: "Face" },
  { id: "cheeks", label: "Cheeks" },
  { id: "neck", label: "Neck" },
  { id: "chest", label: "Chest" },
  { id: "tits", label: "Tits" },
  { id: "stomach", label: "Stomach" },
  { id: "pussy", label: "Pussy" },
  { id: "ass", label: "Ass" },
  { id: "dick", label: "Dick" },
  { id: "leg", label: "Leg" },
  { id: "arm", label: "Arm" },
];

const WRITING_STYLE_OPTIONS = [
  { id: "realistic", label: "Realistic" },
  { id: "stylish", label: "Stylish" },
  { id: "extreme", label: "Extreme" },
];

const GETTING_NAKED_OPTIONS = [
  { id: "natural", label: "Natural" },
  { id: "silicone", label: "Silicone" },
];

const hasVipTag = (collection) =>
  Array.isArray(collection?.tags) &&
  collection.tags.some((tag) =>
    typeof tag === "string" ? tag === "VIP" : tag?.name === "VIP",
  );

const EditImageModal = ({ isOpen, onClose, collection }) => {
  const dispatch = useDispatch();

  const [isOpenCustomizePromptModalOpen, setIsOpenCustomizePromptModalOpen] =
    useState(false);
  const navigate = useNavigate();
  const [isOpenCropModal, setIsOpenCropModal] = useState(false);
  const [cropTarget, setCropTarget] = useState(null); // null | 1 | 2

  const [bodyWritingText, setBodyWritingText] = useState("");

  const [nudifyEnabled, setNudifyEnabled] = useState(false);
  const [upscaleEnabled, setUpscaleEnabled] = useState(false);

  const [customPrompt, setCustomPrompt] = useState("");

  const [seedNumber, setSeedNumber] = useState(
    Math.floor(Math.random() * 10000000) + 1,
  );

  const [where, setWhere] = useState("face");
  const [writingStyle, setWritingStyle] = useState("realistic");
  const [nakedStyle, setNakedStyle] = useState("natural");

  const [uploadedImage, setUploadedImage] = useState(null);
  const [uploadedImage2, setUploadedImage2] = useState(null);

  const user = useSelector(selectUser);
  const loading = useSelector(selectToggleToFavoriteLoading);
  const generateLoading = useSelector(selectGenerateImageCollectionPending);
  const hideCollectionPending = useSelector(selectHideCollectionPending);
  const hideCollectionVipPending = useSelector(selectHideCollectionVipPending);

  const isLoading =
    loading ||
    generateLoading ||
    hideCollectionPending ||
    hideCollectionVipPending;
  const userId = user?._id || user?.id;
  const canManageCollectionVisibility =
    !!userId && ALLOWED_HIDE_COLLECTION_USER_IDS.includes(userId);

  const isEditImageModel = collection?.modelName === EDIT_IMAGE_MODEL_NAME;
  const isGettingNakedModel = collection?.modelName === NUDIFY_MODEL_NAME;
  const isBodywritingModel = collection?.modelName === TEXT_ON_BODY_MODEL_NAME;
  const isDoubleInputImageModel =
    collection?.modelType === QWEN_Z_TWO_INPUT_IMAGES;

  const isUpscaleModel = collection?.modelType === UPSCALE;

  const uploadedImageRef = useRef(null);
  const uploadedImage2Ref = useRef(null);
  const [isExploding, setIsExploding] = useState(false);

  // const [shouldShake, setShouldShake] = useState(false);
  // const [showOutline, setShowOutline] = useState(false);
  // const [agreeTos, setAgreeTos] = useState(false);

  const [flyAnimation, setFlyAnimation] = useState({
    isActive: false,
    imageUrl: null,
    startPosition: null,
    imageDimensions: null,
    onComplete: null,
  });

  const isMobile = useMediaQuery({ maxWidth: 768 });

  const [widthDifference, setWidthDifference] = useState(null);
  const [hideImageContainer, setHideImageContainer] = useState(null);
  const [isCollectionHiddenLocally, setIsCollectionHiddenLocally] =
    useState(false);
  const [isVipTagHiddenLocally, setIsVipTagHiddenLocally] = useState(false);
  const [confirmationAction, setConfirmationAction] = useState(null);

  const [whereBarRef, isWhereFaded] = useScrollFade("horizontal", [
    WHERE_OPTIONS,
    isOpen,
  ]);

  const checkWidthDifference = () => {
    setTimeout(() => {
      if (uploadedImageRef.current) {
        const imageWidth = uploadedImageRef.current.offsetWidth;
        const parentWidth = uploadedImageRef.current.parentElement.offsetWidth;
        const difference = parseInt((parentWidth - imageWidth) / 2);

        const maxDifference = isMobile ? 30 : 35;

        const hide = difference > 0 && difference < maxDifference;

        setWidthDifference(hide ? difference : 0);
        setHideImageContainer(hide);
      }
    }, 0);
  };

  useLockBodyScroll(isOpen || isOpenCustomizePromptModalOpen);

  useEffect(() => {
    setIsCollectionHiddenLocally(collection?.isPublic === false);
    setIsVipTagHiddenLocally(false);
  }, [collection?._id, collection?.isPublic]);

  // const handleCheckboxClick = () => {
  //   const newValue = !agreeTos;
  //   setAgreeTos(newValue);
  //   if (newValue) {
  //     setShowOutline(false);
  //   }
  // };

  const generateRandomSeed = () => {
    return Math.floor(Math.random() * 10000000) + 1;
  };

  const handleFavoriteToggle = () => {
    if (!loading && collection?._id) {
      dispatch(toggleToFavorite({ collectionId: collection?._id }));
    }
  };

  const hideCollectionAction = () => {
    if (!collection?._id || hideCollectionPending) {
      return;
    }

    const willShowCollection = isCollectionHidden;
    const hide = !willShowCollection;

    dispatch(hideCollection({ collectionId: collection._id, hide }))
      .unwrap()
      .then(() => {
        setIsCollectionHiddenLocally(!isCollectionHidden);
        setConfirmationAction(null);
        toast.success(
          willShowCollection
            ? "Collection shown successfully"
            : "Collection hidden successfully",
        );
      })
      .catch((err) => {
        toast.error(
          err ||
            (willShowCollection
              ? "Failed to show collection"
              : "Failed to hide collection"),
        );
      });
  };

  const hideCollectionVipAction = () => {
    if (!collection?._id || hideCollectionVipPending) {
      return;
    }

    const willShowVipTag = isVipTagHiddenLocally;
    const hide = !willShowVipTag;

    dispatch(hideCollectionVip({ collectionId: collection._id, hide }))
      .unwrap()
      .then(() => {
        setIsVipTagHiddenLocally(!isVipTagHiddenLocally);
        setConfirmationAction(null);
        toast.success(
          willShowVipTag
            ? "VIP tag shown successfully"
            : "Collection hidden from VIP category successfully",
        );
      })
      .catch((err) => {
        toast.error(
          err ||
            (willShowVipTag
              ? "Failed to show VIP tag"
              : "Failed to hide collection from VIP"),
        );
      });
  };

  const handleConfirmVisibilityAction = () => {
    if (confirmationAction === "hide") {
      hideCollectionAction();
      return;
    }

    if (confirmationAction === "hideVip") {
      hideCollectionVipAction();
    }
  };

  const selectWhere = (id) => {
    setWhere(id);
  };

  const selectWritingStyle = (id) => {
    setWritingStyle(id);
  };

  const handleImageUpload = async (event) => {
    let file = event.target.files[0];
    if (file) {
      const validTypes = [
        "image/jpeg",
        "image/png",
        "image/jpg",
        "image/webp",
        "image/heic",
        "image/heif",
      ];
      if (!validTypes.includes(file.type)) {
        toast.error("Please upload a valid image file (JPEG, PNG, WEBP)");
        return;
      }

      const maxSize = 10 * 1024 * 1024; // 10MB
      if (file.size > maxSize) {
        toast.error("Image size must be less than 10MB");
        return;
      }

      if (file.type === "image/heic" || file.type === "image/heif") {
        try {
          const convertedBlob = await heic2any({
            blob: file,
            toType: "image/jpg",
            quality: 0.9,
          });

          file = new File(
            [convertedBlob],
            file.name.replace(/\.[^/.]+$/, ".jpg"),
            {
              type: "image/jpg",
              lastModified: Date.now(),
            },
          );
        } catch (err) {
          console.error("HEIC → jpg conversion failed", err);
          return;
        }
      }
      const url = URL.createObjectURL(file);

      setUploadedImage({ file, url });

      const reader = new FileReader();
      // reader.onloadend = () => {
      //   setUploadedImagePreview(reader.result);
      // };
      reader.readAsDataURL(file);
    }
  };

  const handleImageUpload2 = async (event) => {
    let file = event.target.files[0];
    if (file) {
      const validTypes = [
        "image/jpeg",
        "image/png",
        "image/jpg",
        "image/webp",
        "image/heic",
        "image/heif",
      ];
      if (!validTypes.includes(file.type)) {
        toast.error("Please upload a valid image file (JPEG, PNG, WEBP)");
        return;
      }

      const maxSize = 10 * 1024 * 1024; // 10MB
      if (file.size > maxSize) {
        toast.error("Image size must be less than 10MB");
        return;
      }

      if (file.type === "image/heic" || file.type === "image/heif") {
        try {
          const convertedBlob = await heic2any({
            blob: file,
            toType: "image/jpg",
            quality: 0.9,
          });

          file = new File(
            [convertedBlob],
            file.name.replace(/\.[^/.]+$/, ".jpg"),
            {
              type: "image/jpg",
              lastModified: Date.now(),
            },
          );
        } catch (err) {
          console.error("HEIC → jpg conversion failed", err);
          return;
        }
      }
      const url = URL.createObjectURL(file);
      setUploadedImage2({ file, url });
    }
  };

  const validateForm = () => {
    if (collection?.modelName === TEXT_ON_BODY_MODEL_NAME) {
      if (!bodyWritingText || !bodyWritingText.trim()) {
        toast.error("Body writing text is required");
        return false;
      }

      if (!where) {
        toast.error("Please select where to place the text");
        return false;
      }

      if (!writingStyle) {
        toast.error("Please select a writing style");
        return false;
      }
      if (!nakedStyle) {
        toast.error("Please select a style");
        return false;
      }
    } else if (
      collection?.modelName === EDIT_IMAGE_MODEL_NAME &&
      collection?.name === "Edit Image"
    ) {
      if (!customPrompt || customPrompt?.length === 0) {
        toast.error("Please add prompt");
        return false;
      }
    } else if (collection?.modelType === QWEN_Z_TWO_INPUT_IMAGES) {
      if (!uploadedImage || !uploadedImage2) {
        toast.error("Please add input images", 400);
        return false;
      }
    }

    return true;
  };

  const handleConfirm = async () => {
    if (!validateForm()) {
      return;
    }

    // if (!agreeTos) {
    //   setShouldShake(true);
    //   setShowOutline(true);
    //   setTimeout(() => setShouldShake(false), 400);
    //   return;
    // }

    // localStorage.setItem("tosAccepted", "true");

    const formData = new FormData();

    formData.append("collectionId", collection?._id);
    formData.append("nudify", nudifyEnabled);
    formData.append("upscale", upscaleEnabled);

    if (bodyWritingText) {
      formData.append("text", bodyWritingText.trim());
    }
    if (where) {
      formData.append("placement", where);
    }

    if (writingStyle) {
      formData.append("writingStyle", writingStyle);
    }

    if (nakedStyle) {
      formData.append("style", nakedStyle);
    }

    formData.append("modelId", collection.model);

    if (customPrompt && customPrompt.trim()) {
      formData.append("customPrompt", customPrompt.trim());
    }

    if (seedNumber) {
      formData.append("seed", seedNumber);
    } else {
      formData.append("seed", generateRandomSeed());
    }

    if (uploadedImage) {
      formData.append("image", uploadedImage.file);
    }

    if (uploadedImage2) {
      formData.append("image2", uploadedImage2.file);
    }

    dispatch(generateImageCollection(formData))
      .unwrap()
      .then(() => {
        toast.custom(() => (
          <GenerationToast
            label="View"
            onClick={() => {
              navigate("/mine");

              window.scrollTo({
                top: 0,
                left: 0,
                behavior: "instant",
              });
            }}
          />
        ));
        // Trigger explosion animation on button, then fly animation
        setIsExploding(true);

        // After explosion, start fly animation
        setTimeout(() => {
          setIsExploding(false);

          if (uploadedImage && uploadedImageRef.current) {
            setFlyAnimation({
              isActive: true,
              imageUrl: uploadedImage?.url,
              startPosition: uploadedImageRef.current.getBoundingClientRect(),
              imageDimensions: {
                width: uploadedImageRef.current.offsetWidth,
                height: uploadedImageRef.current.offsetHeight,
              },
              onComplete: () => {
                // Navigate to collection after animation
                const alreadyGeneratedVideo = localStorage.getItem(
                  "alreadyGeneratedVideo",
                );
                if (!alreadyGeneratedVideo) {
                  localStorage.setItem("alreadyGeneratedVideo", true);
                  navigate("/mine");

                  window.scrollTo({
                    top: 0,
                    left: 0,
                    behavior: "instant",
                  });
                }

                // Reset animation
                setFlyAnimation({
                  isActive: false,
                  imageUrl: null,
                  startPosition: null,
                  imageDimensions: null,
                  onComplete: null,
                });
              },
            });

            // Close modal immediately when fly animation starts
            handleCancel();
          } else {
            // No image for animation, just close modal
            handleCancel();
          }
        }, 500); // Duration of explosion animation
      })
      .catch((err) => {
        toast.error(
          "An error occurred while generating images. Please try again later.",
        );
      });
  };

  const resetStates = () => {
    setBodyWritingText("");
    setNudifyEnabled(false);
    setUpscaleEnabled(false);
    setWhere("face");
    setWritingStyle("realistic");
    setNakedStyle("natural");
    setCustomPrompt("");
    setUploadedImage(null);
    setUploadedImage2(null);
    // setShouldShake(false);
    // setShowOutline(false);
    // setAgreeTos(false);
  };

  const handleCancel = () => {
    if (!isLoading) {
      resetStates();
      onClose();
    }
  };

  const displayImage =
    uploadedImage?.url ||
    collection?.input?.image?.resizedImage?.url ||
    collection?.input?.image?.url;

  const outputImage =
    collection?.output?.image?.url || collection?.input?.image?.url;
  const showHideVipTagButton =
    canManageCollectionVisibility &&
    (hasVipTag(collection) || isVipTagHiddenLocally);
  const isCollectionHidden =
    isCollectionHiddenLocally || collection?.isPublic === false;
  const confirmationTitle =
    confirmationAction === "hideVip"
      ? isVipTagHiddenLocally
        ? "Show VIP Tag"
        : "Hide VIP Tag"
      : isCollectionHidden
        ? "Show Collection"
        : "Hide Collection";
  const confirmationMessage =
    confirmationAction === "hideVip"
      ? isVipTagHiddenLocally
        ? "Are you sure you want to show this collection in the VIP category?"
        : "Are you sure you want to remove this collection from the VIP category?"
      : isCollectionHidden
        ? "Are you sure you want to show this collection?"
        : "Are you sure you want to hide this collection?";
  const confirmationLoading =
    confirmationAction === "hideVip"
      ? hideCollectionVipPending
      : hideCollectionPending;

  return (
    <>
      <Modal
        isOpen={isOpen}
        onClose={() => {
          if (!isLoading) {
            onClose();
            resetStates();
          }
        }}
        customOverlayStyles={{ zIndex: 3100 }}
      >
        <ModalContainer $isBodywriting={isBodywritingModel}>
          <ModalContent>
            <TitleContainer>
              <Row>
                <ModalTitle>{collection?.name || "Model title"}</ModalTitle>
                <SmallRow>
                  <FavoriteButton style={{ zIndex: 1 }}>
                    <LottieIcon
                      animationData={likeAnimation}
                      trigger="toggle"
                      isToggled={user?.favoriteCollections?.includes(
                        collection?._id,
                      )}
                      onToggle={handleFavoriteToggle}
                      likeSegment={[1, 90]}
                      unlikeSegment={[90, 180]}
                      size={50}
                      absolute
                    />
                  </FavoriteButton>

                  <FavoriteButton
                    onClick={() => {
                      if (!isLoading) {
                        onClose();
                        resetStates();
                      }
                    }}
                  >
                    <CloseSvg />
                  </FavoriteButton>
                </SmallRow>
              </Row>
              <Tags>
                {!!collection?.keywords &&
                  collection?.keywords?.length > 0 &&
                  collection?.keywords.map((keyword, i) => (
                    <Tag key={i}>{keyword}</Tag>
                  ))}
              </Tags>
              {canManageCollectionVisibility && (
                <AdminActionsContainer>
                  <AdminActionButton
                    onClick={() => setConfirmationAction("hide")}
                    disabled={hideCollectionPending}
                  >
                    {hideCollectionPending
                      ? "Saving..."
                      : isCollectionHidden
                        ? "Show"
                        : "Hide"}
                  </AdminActionButton>

                  {showHideVipTagButton && (
                    <AdminActionButton
                      onClick={() => setConfirmationAction("hideVip")}
                      disabled={hideCollectionVipPending}
                    >
                      {hideCollectionVipPending
                        ? "Saving..."
                        : isVipTagHiddenLocally
                          ? "Show VIP tag"
                          : "Hide VIP tag"}
                    </AdminActionButton>
                  )}
                </AdminActionsContainer>
              )}
            </TitleContainer>
            <ImageRelative style={{ width: "100%" }}>
              {isDoubleInputImageModel ? (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "8px",
                  }}
                >
                  <ImageContainer
                    style={{
                      height: 116,
                      maxHeight: 116,
                    }}
                  >
                    {uploadedImage && (
                      <DeleteButton
                        onClick={() => {
                          setUploadedImage(null);
                        }}
                      >
                        <LottieIcon
                          animationData={deleteAnimation}
                          trigger="hover"
                          size={24}
                          strokeColor={"#fff"}
                        />
                      </DeleteButton>
                    )}
                    {uploadedImage && (
                      <CropButton
                        onClick={() => {
                          setCropTarget(1);
                          setIsOpenCropModal(true);
                        }}
                      >
                        <CropIcon />
                      </CropButton>
                    )}
                    <Image
                      src={uploadedImage?.url || collection?.input.image.url}
                      alt="Model Before Image 1"
                      ref={uploadedImageRef}
                      $hideImageContainer={!uploadedImage?.url}
                    />
                    <input
                      type="file"
                      accept="image/jpeg,image/png,image/jpg,image/webp,image/heic,image/heif"
                      style={{ display: "none" }}
                      id="image-upload"
                      onChange={handleImageUpload}
                      disabled={isLoading}
                    />
                    <UploadButton as="label" htmlFor="image-upload">
                      {uploadedImage ? "Change Image" : "Upload Image"}
                    </UploadButton>
                  </ImageContainer>
                  <ImageContainer
                    style={{
                      height: 116,
                      maxHeight: 116,
                    }}
                  >
                    {uploadedImage2 && (
                      <DeleteButton
                        onClick={() => {
                          setUploadedImage2(null);
                        }}
                      >
                        <LottieIcon
                          animationData={deleteAnimation}
                          trigger="hover"
                          size={24}
                          strokeColor={"#fff"}
                        />
                      </DeleteButton>
                    )}
                    {uploadedImage2 && (
                      <CropButton
                        onClick={() => {
                          setCropTarget(2);
                          setIsOpenCropModal(true);
                        }}
                      >
                        <CropIcon />
                      </CropButton>
                    )}
                    <Image
                      src={
                        uploadedImage2?.url ||
                        collection?.input.image.resizedImage.url
                      }
                      alt="Model Before Image 2"
                      ref={uploadedImage2Ref}
                      $hideImageContainer={!uploadedImage2?.url}
                    />
                    <input
                      type="file"
                      accept="image/jpeg,image/png,image/jpg,image/webp,image/heic,image/heif"
                      style={{ display: "none" }}
                      id="image-upload-2"
                      onChange={handleImageUpload2}
                      disabled={isLoading}
                    />
                    <UploadButton as="label" htmlFor="image-upload-2">
                      {uploadedImage2 ? "Change Image" : "Upload Image"}
                    </UploadButton>
                  </ImageContainer>
                </div>
              ) : (
                <ImageContainer>
                  {uploadedImage && (
                    <DeleteButton
                      onClick={() => {
                        setUploadedImage(null);
                      }}
                    >
                      <LottieIcon
                        animationData={deleteAnimation}
                        trigger="hover"
                        size={24}
                        strokeColor={"#fff"}
                      />
                    </DeleteButton>
                  )}
                  {uploadedImage && (
                    <CropButton
                      $shift={widthDifference}
                      onClick={() => {
                        setCropTarget(null);
                        setIsOpenCropModal(true);
                      }}
                    >
                      <CropIcon />
                    </CropButton>
                  )}

                  <Image
                    src={displayImage}
                    alt="Model Before Image"
                    onLoad={checkWidthDifference}
                    ref={uploadedImageRef}
                    $hideImageContainer={
                      hideImageContainer || !uploadedImage?.url
                    }
                  />
                  <input
                    type="file"
                    accept="image/jpeg,image/png,image/jpg,image/webp,image/heic,image/heif"
                    style={{ display: "none" }}
                    id="image-upload"
                    onChange={handleImageUpload}
                    disabled={isLoading}
                  />
                  <UploadButton as="label" htmlFor="image-upload">
                    {uploadedImage ? "Change Image" : "Upload Image"}
                  </UploadButton>
                </ImageContainer>
              )}
              <ArrowSvg />

              <ImageContainer>
                <Image
                  src={outputImage}
                  alt="Model After Image"
                  $hideImageContainer
                />
              </ImageContainer>
            </ImageRelative>

            {!isBodywritingModel &&
              !isUpscaleModel &&
              !isDoubleInputImageModel && (
                <SettingsContainer>
                  <NudifyContainer
                    onClick={() => {
                      if (!isLoading) {
                        setUpscaleEnabled(!upscaleEnabled);
                      }
                    }}
                  >
                    <LottieIcon
                      animationData={checkboxAnimation}
                      speed={2}
                      trigger="toggle-reverse"
                      isActive={upscaleEnabled}
                      onActiveChange={() => {
                        if (!isLoading) {
                          setUpscaleEnabled(!upscaleEnabled);
                        }
                      }}
                      onClick={() => {
                        if (!isLoading) {
                          setUpscaleEnabled(!upscaleEnabled);
                        }
                      }}
                      size={24}
                      strokeColor={!upscaleEnabled ? "var(--color-brand-700)" : "#ffffff"}
                    />
                    <NudifyText>Upscale before editing image</NudifyText>
                  </NudifyContainer>
                </SettingsContainer>
              )}

            {isGettingNakedModel ? (
              <SettingsContainer>
                <Column>
                  <LabelText>Style</LabelText>

                  <CheckboxContainerRow>
                    {GETTING_NAKED_OPTIONS.map((option) => {
                      const isChecked = nakedStyle === option.id;

                      return (
                        <Checkbox
                          $checked={isChecked}
                          key={option.id}
                          onClick={() => !isLoading && setNakedStyle(option.id)}
                        >
                          <LottieIcon
                            animationData={radioButtonAnimation}
                            speed={2}
                            trigger="toggle-reverse"
                            isActive={isChecked}
                            size={22}
                            strokeColor={!isChecked ? "var(--color-brand-700)" : "#ffffff"}
                          />

                          <CheckboxText>{option.label}</CheckboxText>
                        </Checkbox>
                      );
                    })}
                  </CheckboxContainerRow>
                </Column>
              </SettingsContainer>
            ) : isBodywritingModel ? (
              <SettingsContainer>
                <NudifyContainer
                  onClick={() => {
                    if (!isLoading) {
                      setUpscaleEnabled(!upscaleEnabled);
                    }
                  }}
                >
                  <LottieIcon
                    animationData={checkboxAnimation}
                    speed={2}
                    trigger="toggle-reverse"
                    isActive={upscaleEnabled}
                    onActiveChange={() => {
                      if (!isLoading) {
                        setUpscaleEnabled(!upscaleEnabled);
                      }
                    }}
                    onClick={() => {
                      if (!isLoading) {
                        setUpscaleEnabled(!upscaleEnabled);
                      }
                    }}
                    size={24}
                    strokeColor={!upscaleEnabled ? "var(--color-brand-700)" : "#ffffff"}
                  />
                  <NudifyText>Upscale before applying text</NudifyText>
                </NudifyContainer>
                <NudifyContainer
                  onClick={() => {
                    if (!isLoading) {
                      setNudifyEnabled(!nudifyEnabled);
                    }
                  }}
                >
                  <LottieIcon
                    animationData={checkboxAnimation}
                    speed={2}
                    trigger="toggle-reverse"
                    isActive={nudifyEnabled}
                    onActiveChange={() => {
                      if (!isLoading) {
                        setNudifyEnabled(!nudifyEnabled);
                      }
                    }}
                    onClick={() => {
                      if (!isLoading) {
                        setNudifyEnabled(!nudifyEnabled);
                      }
                    }}
                    size={24}
                    strokeColor={!nudifyEnabled ? "var(--color-brand-700)" : "#ffffff"}
                  />
                  <NudifyText>Nudify before applying text</NudifyText>
                </NudifyContainer>

                <Column>
                  <SmallRow>
                    <LabelText>Text</LabelText>
                    {/* <InfoIcon width={18} height={18} /> */}
                  </SmallRow>
                  <Input
                    type="text"
                    placeholder="Enter the bodywriting text…"
                    value={bodyWritingText}
                    onChange={(e) => setBodyWritingText(e.target.value)}
                    disabled={isLoading}
                  />
                </Column>

                <Column>
                  <LabelText>Where?</LabelText>

                  <FadeWrapper $faded={isWhereFaded}>
                    <CheckboxContainer ref={whereBarRef}>
                      {WHERE_OPTIONS.map((option) => {
                        const isChecked = where === option.id;

                        return (
                          <Checkbox
                            key={option.id}
                            $checked={isChecked}
                            onClick={() => !isLoading && selectWhere(option.id)}
                          >
                            <LottieIcon
                              animationData={radioButtonAnimation}
                              trigger="toggle-reverse"
                              speed={2}
                              isActive={isChecked}
                              size={22}
                              strokeColor={!isChecked ? "var(--color-brand-700)" : "#ffffff"}
                            />
                            <CheckboxText>{option.label}</CheckboxText>
                          </Checkbox>
                        );
                      })}
                    </CheckboxContainer>
                  </FadeWrapper>
                </Column>

                <Column>
                  <LabelText>Writing Style</LabelText>

                  <CheckboxContainerRow>
                    {WRITING_STYLE_OPTIONS.map((option) => {
                      const isChecked = writingStyle === option.id;

                      return (
                        <Checkbox
                          $checked={isChecked}
                          key={option.id}
                          onClick={() =>
                            !isLoading && selectWritingStyle(option.id)
                          }
                        >
                          <LottieIcon
                            animationData={radioButtonAnimation}
                            speed={2}
                            trigger="toggle-reverse"
                            isActive={isChecked}
                            strokeColor={!isChecked ? "var(--color-brand-700)" : "#ffffff"}
                            size={22}
                          />
                          <CheckboxText>{option.label}</CheckboxText>
                        </Checkbox>
                      );
                    })}
                  </CheckboxContainerRow>
                </Column>
              </SettingsContainer>
            ) : collection?.name === "Edit Image" || isDoubleInputImageModel ? (
              <SettingsContainer>
                <Column>
                  <SmallRow>
                    <LabelText>Prompt</LabelText>
                  </SmallRow>
                  <Textarea
                    style={{
                      minHeight: isDoubleInputImageModel ? 88 : 126,
                    }}
                    type="text"
                    placeholder={
                      isDoubleInputImageModel
                        ? "Woman hugs man"
                        : (collection?.customPrompt ??
                          "Enter the custom prompt here")
                    }
                    value={customPrompt}
                    onChange={(e) => setCustomPrompt(e.target.value)}
                    disabled={isLoading}
                  />
                </Column>
              </SettingsContainer>
            ) : (
              <></>
            )}

            <ButtonGroup>
              <LottieIcon
                animationData={settingsAnimation}
                trigger="hover"
                strokeColor={"#fff"}
                size={28}
                onClick={() =>
                  !isLoading && setIsOpenCustomizePromptModalOpen(true)
                }
              />
              <ExplosionButton
                style={{ flex: 1, minWidth: 0 }}
                disabled={generateLoading}
                onClick={handleConfirm}
                isLoading={generateLoading}
                isExploding={isExploding}
                small
              >
                {generateLoading ? (
                  <l-bouncy size="18" speed="0.9" color="white" />
                ) : (
                  // <l-pulsar
                  //   size="24"
                  //   stroke="2"
                  //   speed="2.2"
                  //   color="rgba(63, 136, 247, 1)"
                  // />
                  <>
                    Generate
                    <CreditIcon />
                    {nudifyEnabled
                      ? upscaleEnabled
                        ? 45
                        : 30
                      : upscaleEnabled
                        ? 30
                        : 15}
                  </>
                )}
              </ExplosionButton>
            </ButtonGroup>
            {/* <TermsCheckboxComponent
              handleCheckboxClick={handleCheckboxClick}
              agreeTos={agreeTos}
              shouldShake={shouldShake}
              showOutline={showOutline}
              offMarginTop
              offHorizontalMargin
              showAlways
            /> */}
          </ModalContent>
        </ModalContainer>
      </Modal>

      <CropModal
        selectedImage={cropTarget === 2 ? uploadedImage2 : uploadedImage}
        onClose={() => {
          setIsOpenCropModal(false);
          setCropTarget(null);
        }}
        onConfirm={(croppedImageData) => {
          const cropped = {
            file: new File(
              [croppedImageData.blob],
              `cropped-${Date.now()}.jpg`,
              { type: "image/jpeg" },
            ),
            url: croppedImageData.url,
            blob: croppedImageData.blob,
          };
          if (cropTarget === 2) {
            setUploadedImage2(cropped);
          } else {
            setUploadedImage(cropped);
          }
          setCropTarget(null);
        }}
        isOpen={isOpenCropModal}
      />

      <ConfirmationModal
        isOpen={!!confirmationAction}
        onClose={() => setConfirmationAction(null)}
        onConfirm={handleConfirmVisibilityAction}
        title={confirmationTitle}
        message={confirmationMessage}
        confirmText="Confirm"
        cancelText="Cancel"
        confirmButtonType="danger"
        isLoading={confirmationLoading}
      />

      <CustomizeEditImageModal
        isOpen={isOpenCustomizePromptModalOpen}
        onClose={() => setIsOpenCustomizePromptModalOpen(false)}
        customPrompt={customPrompt}
        setCustomPrompt={setCustomPrompt}
        seedNumber={seedNumber}
        setSeedNumber={setSeedNumber}
        generateRandomSeed={generateRandomSeed}
        collectionSeed={collection?.seed}
        isEditImageModel={
          (isEditImageModel && collection?.name === "Edit Image") ||
          isDoubleInputImageModel
        }
        resetSeed={isOpen}
      />

      {flyAnimation.isActive && (
        <FlyToCollection
          isActive={flyAnimation.isActive}
          imageUrl={flyAnimation.imageUrl}
          startPosition={flyAnimation.startPosition}
          imageDimensions={flyAnimation.imageDimensions}
          onComplete={() => {
            dispatch(triggerCollectionTabAnimation());

            // Call callback from handleConfirm if provided
            if (flyAnimation.onComplete) {
              flyAnimation.onComplete();
            }

            setFlyAnimation({
              isActive: false,
              imageUrl: null,
              startPosition: null,
              imageDimensions: null,
              onComplete: null,
            });
          }}
        />
      )}
    </>
  );
};

export default EditImageModal;
